/* ============
 * Russian Language File
 * ============
 */

import login from './login'
import shared from './shared'
import home from './home'
import settings from './settings'
import user from './user'
import task from './task'
import legalEntity from './legalEntity'
import customer from './customer'
import techMap from './techMap'
import financeInvoice from './financeInvoice'

export default {
  nowDate: 'Текущая дата',
  login,
  shared,
  home,
  settings,
  user,
  task,
  legal_entity: legalEntity,
  customer,
  tech_map: techMap,
  financeInvoice,
  datetime: 'Дата',
  number: 'Номер',
  parent_datetime: 'Дата родительского',
  parent_number: 'Номер родительского'
}
